module.exports = __webpack_public_path__ + "img/noun-government-286709.c9c9d29f.svg";